import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65b014a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-close-content-block-wrap" }
const _hoisted_2 = { class: "account-close-content-block" }
const _hoisted_3 = { vclass: "account-close-content-block-title margin-l-r" }
const _hoisted_4 = ["innerHTML"]

import {WrapTitle} from "@/entities";
import {useLocalizationStore} from "@/shared";
// import {LatestNews} from "@/features";

// const props = defineProps({
//   showSelectedNews: {
//     type: Boolean,
//     default: false,
//   },
// });

export default /*#__PURE__*/_defineComponent({
  __name: 'account-close-content',
  setup(__props) {

const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(WrapTitle), {
          text: _unref(translate)('account_close_title'),
          class: "account-close-content-block-wrap-title",
          size: "regular",
          weight: "700"
        }, null, 8, ["text"]),
        _createElementVNode("div", {
          class: "account-close-content-block-sub-title",
          style: {"margin-top":"30px","margin-bottom":"30px","font-size":"16px"},
          innerHTML: _unref(translate)('account_close_content')
        }, null, 8, _hoisted_4)
      ])
    ])
  ]))
}
}

})